<script setup lang="ts">
import { useTranslate } from '@/shared/lib'
import './assets/style.scss'

const { languages, setLocale, getLocaleValue } = useTranslate()
</script>

<template>
  <div class="lang">
    <VBtn class="lang__button" variant="text" color="default">
      <span class="material-symbols-rounded">translate</span>
      {{ getLocaleValue() }}

      <VMenu activator="parent">
        <VList>
          <VListItem
            v-for="(lang, key) in languages"
            :key="key"
            :value="key"
            @click="setLocale(key as string)"
          >
            <VListItemTitle class="lang__item">
              <img class="lang__icon" :src="`/images/lang/${key}.svg`" :alt="lang" />
              {{ lang }}
            </VListItemTitle>
          </VListItem>
        </VList>
      </VMenu>
    </VBtn>
  </div>
</template>
